// extracted by mini-css-extract-plugin
module.exports = {"jsonContainer":"AssessmentDiffDefinition_jsonContainer__3B0qw","diffContainer":"AssessmentDiffDefinition_diffContainer__ameD0"};